module.exports = __webpack_public_path__ + "img/logo_driver_cuadrado.8b74e0c4.png";